import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, MarkExtension, ExtensionTag, toggleMark } from '@remirror/core';

var _dec, _class, _temp;
var UnderlineExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = (_temp = class UnderlineExtension extends MarkExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.FontStyle]);
  }

  get name() {
    return 'underline';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'u',
        getAttrs: extra.parse
      }, {
        style: 'text-decoration',
        getAttrs: node => node === 'underline' ? {} : false
      }],
      toDOM: mark => ['u', extra.dom(mark), 0]
    };
  }

  createKeymap() {
    return {
      'Mod-u': toggleMark({
        type: this.type
      })
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the underline formatting of the selected text.
       */
      toggleUnderline: () => toggleMark({
        type: this.type
      })
    };
  }

}, _temp)) || _class);

export { UnderlineExtension };
